import { render, staticRenderFns } from "./Startflow.vue?vue&type=template&id=3dc3881c&scoped=true&"
import script from "./Startflow.vue?vue&type=script&lang=js&"
export * from "./Startflow.vue?vue&type=script&lang=js&"
import style0 from "./Startflow.vue?vue&type=style&index=0&id=3dc3881c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3881c",
  null
  
)

export default component.exports